import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { SiTrackPage } from '../../../components/si-track-page';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { Project } from '../../../models/project';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { Button, Grid, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { TabPanel } from '../../../components/tab-panel';
import { EditProjectDetailsTab } from './edit-project-details.tab';
import { EditProjectBuildingTab } from './edit-project-building.tab';
import { useSearchParams } from 'react-router-dom';
import { UserPermissionName } from '../../../models/user-permission-name';
import { useAuthorize } from '../../../hooks/use-authorize';
import { Icons } from '../../../assets/icons';

const styling = {
  root: { paddingRight: '15px', paddingBottom: '10px' },
  buttonStyle: { width: '130px' },
};

export const EditProjectPage = () => {
  const { projectID } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const currentTabValue: 'details' | 'buildings' = searchParams.get('tab') as any;
  const [currentTab, setCurrentTab] = useState<'details' | 'buildings'>(currentTabValue ?? 'details');
  const { isLoading, isFetching, data, refetch } = useLoadData<ApiResponse<Project>>(
    projectsApiKeyStore.getProjectDetails(Number(projectID))
  );

  const handleTabsChange = (event: any, value: any) => {
    setCurrentTab(value);
    refetch();
  };

  const showTab = (tab: 'details' | 'buildings') => {
    setCurrentTab(tab);
  };
  const isViewUnitPermission = useAuthorize([UserPermissionName.VIEW_UNIT]);
  const isViewProjectEditPermission = useAuthorize([UserPermissionName.EDIT_PROJECT]);
  const PermissionErrorComponent = () => {
    const fullScreenMsg = {
      padding: '0 60px 60px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    };

    return (
      <Grid style={fullScreenMsg}>
        <Grid
          style={{
            color: 'black',
            backgroundColor: '#fff',
            padding: '120px 40px',
            borderRadius: '10px',
            minWidth: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <div className="icon">
            <img src={Icons.IconDeniedGraphics} alt="SI Track" />
          </div>
          <div className="content" style={{ textAlign: 'left', paddingLeft: '60px' }}>
            <h1 style={{ marginBottom: '20px' }}>Access Denied!</h1>
            <p>You don&apos;t have permission to access this page.</p>
          </div>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      {!isViewUnitPermission && !isViewProjectEditPermission ? (
        <PermissionErrorComponent />
      ) : (
        <SiTrackPage title="Edit Project" isLoading={isLoading}>
          <Tabs value={currentTab} onChange={handleTabsChange}>
            <Tab value="details" label="PROJECT INFO" hidden={!isViewProjectEditPermission} />
            <Tab value="buildings" label="LOTS/UNITS" hidden={!isViewUnitPermission} />
          </Tabs>
          {data?.data && (
            <>
              {isViewProjectEditPermission && (
                <TabPanel selectedValue={currentTab} value="details">
                  <EditProjectDetailsTab oldProject={data?.data} parentLoading={isLoading || isFetching} pageAction='edit' showTab={showTab} refetchProjectDetails={refetch} />
                </TabPanel>
              )}
              {isViewUnitPermission && (
                <TabPanel selectedValue={currentTab} value="buildings">
                  <EditProjectBuildingTab project={data?.data} />
                  <Grid container justifyContent="space-between" spacing={1}>
                    <Grid item>
                      <Button
                        variant="outlined"
                        style={styling.buttonStyle}
                        onClick={() => {
                          navigate('/projects');
                        }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </TabPanel>
              )}
            </>
          )}
        </SiTrackPage>
      )}
    </>
  );
};
